import React from "react";

const Wrapper = ({ children, className, style }) => (
  <div
    className={`mx-3 ${className}`}
    style={{ display: "flex", flex: 1, flexDirection: "column", ...style }}
  >
    {children}
  </div>
);

export default Wrapper;
